import React from 'react';
import './VerificationCode.less';
import InputItem from 'antd-mobile/lib/input-item';
import autobind from 'autobind-decorator';

class VerificationCode extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'verification'
    };

    isChange: boolean = true; // 是否触发输入框值改变事件

    constructor(props, context) {
        super(props, context);
        this.state = {
            codeArr: ['', '', '', '', '', ''],
            keyCodeArr: {
                '48': '0',
                '49': '1',
                '50': '2',
                '51': '3',
                '52': '4',
                '53': '5',
                '54': '6',
                '55': '7',
                '56': '8',
                '57': '9'
            }
        };
    }

    // 通过input值改变触发
    @autobind
    private onChangeCode(index, value): any {
        if (!this.isChange) return;
        if (value === '') return;
        let newCodeArr: string[] = this.state.codeArr.slice(0);
        newCodeArr[index] = value;
        this.setState({
            codeArr: newCodeArr
        });
        if (this.props.onChangeValue) {
            this.props.onChangeValue('code', newCodeArr)
        }
        if (index === newCodeArr.length - 1) return;
        (this.refs[`inputRef${index + 1}`] as any).focus();
    }

    // 通过按键触发
    @autobind
    private onChangeCode_hand(index, value): any {
        this.isChange = false;
        let newCodeArr: string[] = this.state.codeArr.slice(0);
        newCodeArr[index] = value;
        this.setState({
            codeArr: newCodeArr
        });
        if (index === 5) {
            (this.refs[`inputRef${index}`] as any).focus();
        }
        if (this.props.onChangeValue) {
            this.props.onChangeValue('code', newCodeArr)
        }
        if (index === newCodeArr.length - 1) return;
        (this.refs[`inputRef${index + 1}`] as any).focus();
    }

    // 删除验证码
    @autobind
    private onDeleteCode(e, index): any {
        let newCodeArr: string[] = this.state.codeArr.slice(0);
        if (e.keyCode === 8) {
            this.isChange = false;
            if (index !== 0) {
                (this.refs[`inputRef${index - 1}`] as any).focus();
            }
            newCodeArr[index] = '';
            this.setState({
                codeArr: newCodeArr
            });
        } else if (e.keyCode >= 48 && e.keyCode <= 57 && newCodeArr[index].length !== 0) {
            this.isChange = true;
            if (index === newCodeArr.length - 1) return;
            this.onChangeCode_hand(index + 1, this.state.keyCodeArr[e.keyCode]);
        } else {
            this.isChange = true;
        }
    }

    // 点击浮层获取焦点
    @autobind
    private onFocusCode(): void {
        const {codeArr} = this.state;
        const len: number = codeArr.length;
        let index: number = 0;
        for (let i: number = 0; i < len; i++) {
            if (codeArr[0].length === 0) break;
            if (codeArr[5].length === 1) {
                index = 5;
                break;
            }
            if (codeArr[i].length === 0) {
                index = i;
                break;
            }
        }
        (this.refs[`inputRef${index}`] as any).focus();
        if (this.props.isRenderHeight) {
            this.props.isRenderHeight()
        }
    }

    render() {
        const {prefixCls, onBlurHeight} = this.props;
        const {codeArr} = this.state;
        return (
            <div className={`${prefixCls} clearfix`}>
                <div className={`${prefixCls}-cover`} onClick={this.onFocusCode}/>
                {
                    codeArr.map((item: any, index: number) => {
                        return (
                            <div className={`${prefixCls}-input-box`} key={index} onKeyDown={(e) => {
                                this.onDeleteCode(e, index);
                            }}>
                                <InputItem
                                    ref={`inputRef${index}`}
                                    type="number"
                                    value={item}
                                    maxLength={1}
                                    onBlur={onBlurHeight}
                                    onChange={(value) => {
                                        this.onChangeCode(index, value);
                                    }}
                                />
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default VerificationCode;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/verificationCode/VerificationCode.tsx